import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Login from "./pages/Login";

//admin routes
// import Partners from "./pages/admin/partners";
import Clients from "./pages/admin/clients";
import SalesPoints from "./pages/admin/salesPoints";
import Sales from "./pages/admin/sales";
import Products from "./pages/admin/products";
import Users from "./pages/admin/users";

//saler routes
import SalerSales from "./pages/saler/sales";
import Spheres from "./pages/admin/spheres";

function App() {
  return (
    <Router>
      <div className="wrapper">
        <Routes>
          <Route path="/" element={<Login />} />
          {/* <Route path='/partners' element={<RequireAuth><Partners role="1"/></RequireAuth>} /> */}
          <Route
            path="/clients"
            element={
              <RequireAuth>
                <Clients role="1" />
              </RequireAuth>
            }
          />
          <Route
            path="/sales-points"
            element={
              <RequireAuth>
                <SalesPoints role="1" />
              </RequireAuth>
            }
          />
          <Route
            path="/spheres"
            element={
              <RequireAuth>
                <Spheres role="1" />
              </RequireAuth>
            }
          />
          <Route
            path="/sales"
            element={
              <RequireAuth>
                <Sales role="1" />
              </RequireAuth>
            }
          />
          <Route
            path="/products"
            element={
              <RequireAuth>
                <Products role="1" />
              </RequireAuth>
            }
          />
          <Route
            path="/users"
            element={
              <RequireAuth>
                <Users role="1" />
              </RequireAuth>
            }
          />
          <Route
            path="/saler-sales"
            element={
              <RequireAuth>
                <SalerSales role="2" />
              </RequireAuth>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

function RequireAuth({ children }) {
  let location = useLocation();
  if (!localStorage.getItem("ttk") || jwtDecode(localStorage.getItem("ttk")).role != 99) {
    if (!localStorage.getItem("ttk") || jwtDecode(localStorage.getItem("ttk")).role != Number(children.props.role)) {
      localStorage.clear();
      return <Navigate to="/" state={{ from: location }} replace />;
    }
  }
  return children;
}
